<template>
    <div>


<!--        <b-tabs  >-->

<!--            <b-tab-item label="List of Order">-->
<!--                <b-button type="is-success" icon-left="refresh"  @click="reloadNewOrder" outlined   > Refresh Order List</b-button>-->
<!--                <hr>-->
<!--                <b-table-->
<!--                        :data="isEmpty ? [] : ordersList "-->
<!--                        bordered-->
<!--                        striped-->
<!--                        narrowed-->
<!--                        hoverable-->
<!--                        :loading="isLoading"-->
<!--                        focusable-->
<!--                        mobile-cards-->
<!--                >-->
<!--                    &lt;!&ndash;            checkable&ndash;&gt;-->
<!--                    &lt;!&ndash;            :selected.sync="rowsSelected"&ndash;&gt;-->



<!--                    <template slot-scope="props">-->

<!--                        <b-table-column  label="OrderLab No." centered>-->
<!--                            {{ props.row.idlaborder }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="OPD no."   centered>-->
<!--                            {{props.row.opd_no}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Pet Name"  centered>-->
<!--                            {{props.row.opd_name}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Owner Name"  centered>-->
<!--                            {{props.row.owner_name}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Date/Time"  centered>-->
<!--                            {{customFormatDateF(props.row.date)}} - {{props.row.time}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Group of /Request"  centered>-->
<!--                            {{props.row.grp_name}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Requested By"  centered>-->
<!--                            {{props.row.user_rec_name}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Assign/Create Lab No."  centered>-->
<!--                            <b-button type="is-info" @click="showAssignJob(props.row)">Assign</b-button>-->
<!--                        </b-table-column>-->

<!--                        <b-table-column label="Delete"  centered>-->
<!--                            <b-button type="is-danger" @click="toDelete(props.row.idlaborder)" >Delete</b-button>-->
<!--                        </b-table-column>-->





<!--                    </template>-->

<!--                    <template slot="empty">-->
<!--                        <section class="section">-->
<!--                            <div class="content has-text-grey has-text-centered">-->
<!--                                <p>-->
<!--                                    <b-icon-->
<!--                                            icon="emoticon-sad"-->
<!--                                            size="is-large">-->
<!--                                    </b-icon>-->
<!--                                </p>-->
<!--                                <p>Nothing here.</p>-->
<!--                            </div>-->
<!--                        </section>-->
<!--                    </template>-->
<!--                    <template slot="footer"  >-->
<!--&lt;!&ndash;                        <div class="box" >&ndash;&gt;-->
<!--                            &lt;!&ndash;                    <div  class="level-left" >    <b>Total checked</b>: {{ checkedRows.length }}</div>&ndash;&gt;-->
<!--                            &lt;!&ndash;                    {{ rowsSelected }}&ndash;&gt;-->
<!--&lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                    </template>-->
<!--                    &lt;!&ndash;                                                <template slot="bottom-left">&ndash;&gt;-->
<!--                    &lt;!&ndash;                                                    <b>Total checked</b>: {{ checkedRows.length }}&ndash;&gt;-->


<!--                    &lt;!&ndash;                                                </template>&ndash;&gt;-->

<!--                    &lt;!&ndash;                                                <div class="box ">&ndash;&gt;-->
<!--                    &lt;!&ndash;&lt;!&ndash;                                                    <div  class="level-left" > <div class="level-item"> <b>Total checked</b>: {{ checkedRows.length }}</div></div>&ndash;&gt;&ndash;&gt;-->
<!--                    &lt;!&ndash;                                                    <div  class="level-right" > <div class="level-item"> <b-button type="is-primary" outlined v-show="lnList.length>0" >More..</b-button></div></div>&ndash;&gt;-->
<!--                    &lt;!&ndash;                                                </div>&ndash;&gt;-->

<!--                </b-table>-->
<!--            </b-tab-item>-->

<!--            <b-tab-item label="Completed Order">-->

<!--                <b-button type="is-success" icon-left="refresh"    outlined   > Refresh Order List</b-button>-->
<!--                <hr>-->
<!--                <b-table-->
<!--                        :data="isEmpty ? [] : ordersListCompleted "-->
<!--                        bordered-->
<!--                        striped-->
<!--                        narrowed-->
<!--                        hoverable-->
<!--                        :loading="isLoading"-->
<!--                        focusable-->
<!--                        mobile-cards-->
<!--                >-->
<!--                    &lt;!&ndash;            checkable&ndash;&gt;-->
<!--                    &lt;!&ndash;            :selected.sync="rowsSelected"&ndash;&gt;-->



<!--                    <template slot-scope="props">-->

<!--                        <b-table-column  label="OrderLab No." centered>-->
<!--                            {{ props.row.idlaborder }}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="OPD no."   centered>-->
<!--                            {{props.row.opd_no}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Pet Name"  centered>-->
<!--                            {{props.row.opd_name}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Owner Name"  centered>-->
<!--                            {{props.row.owner_name}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Date/Time"  centered>-->
<!--                            {{customFormatDateF(props.row.date)}} - {{props.row.time}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Group of /Request"  centered>-->
<!--                            {{props.row.grp_name}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Requested By"  centered>-->
<!--                            {{props.row.user_rec_name}}-->
<!--                        </b-table-column>-->
<!--                        <b-table-column label="Assign/Create Lab No."  centered>-->
<!--                            <b-button type="is-info" @click="showAssignJob(props.row)">Re-Assign</b-button>-->
<!--                        </b-table-column>-->







<!--                    </template>-->

<!--                    <template slot="empty">-->
<!--                        <section class="section">-->
<!--                            <div class="content has-text-grey has-text-centered">-->
<!--                                <p>-->
<!--                                    <b-icon-->
<!--                                            icon="emoticon-sad"-->
<!--                                            size="is-large">-->
<!--                                    </b-icon>-->
<!--                                </p>-->
<!--                                <p>Nothing here.</p>-->
<!--                            </div>-->
<!--                        </section>-->
<!--                    </template>-->
<!--                    <template slot="footer"  >-->
<!--                        &lt;!&ndash;                        <div class="box" >&ndash;&gt;-->
<!--                        &lt;!&ndash;                    <div  class="level-left" >    <b>Total checked</b>: {{ checkedRows.length }}</div>&ndash;&gt;-->
<!--                        &lt;!&ndash;                    {{ rowsSelected }}&ndash;&gt;-->
<!--                        &lt;!&ndash;                        </div>&ndash;&gt;-->
<!--                    </template>-->
<!--                    &lt;!&ndash;                                                <template slot="bottom-left">&ndash;&gt;-->
<!--                    &lt;!&ndash;                                                    <b>Total checked</b>: {{ checkedRows.length }}&ndash;&gt;-->


<!--                    &lt;!&ndash;                                                </template>&ndash;&gt;-->

<!--                    &lt;!&ndash;                                                <div class="box ">&ndash;&gt;-->
<!--                    &lt;!&ndash;&lt;!&ndash;                                                    <div  class="level-left" > <div class="level-item"> <b>Total checked</b>: {{ checkedRows.length }}</div></div>&ndash;&gt;&ndash;&gt;-->
<!--                    &lt;!&ndash;                                                    <div  class="level-right" > <div class="level-item"> <b-button type="is-primary" outlined v-show="lnList.length>0" >More..</b-button></div></div>&ndash;&gt;-->
<!--                    &lt;!&ndash;                                                </div>&ndash;&gt;-->

<!--                </b-table>-->
<!--            </b-tab-item>-->
<!--        </b-tabs>-->


        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <b-button type="is-success" icon-left="refresh"  @click="reloadNewOrder" outlined   > Refresh Order List</b-button>
                </div>
                <div class="level-item">
                    <b-button type="is-success" icon-left="cloud-check"  @click="completedOrder" outlined   > Completed Order</b-button>
                </div>
            </div>
            <div class="level-right">
            </div>
        </nav>


        <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                    <b-dropdown
                            v-model="datWantToSee"
                            multiple
                            aria-role="list">
                        <button class="button  is-success" type="button" slot="trigger" >
                            <span>Filter to ({{ datWantToSee.length }})</span>
                            <b-icon icon="menu-down"></b-icon>
                        </button  >

                        <b-dropdown-item v-for="datGrpUniq in datGrpUniqs" :value="datGrpUniq" :key="datGrpUniq" aria-role="listitem">
                            <span>{{datGrpUniq}}</span>
                        </b-dropdown-item>

                    </b-dropdown>
                </div>
                <div class="level-item">
                    <b-taglist>
                        <b-tag type="is-primary" v-for="datWantToSee_ in datWantToSee" :key="datWantToSee_">{{datWantToSee_}}
                        </b-tag>
                    </b-taglist>
                </div>
            </div>
            <div class="level-right">
                <div class="level-item">
                   <b-button type="is-primary is-light" @click="datWantToSee = []"  icon-left="close">Clear Filter</b-button>
                </div>
            </div>
        </nav>            &nbsp;









                        <hr>
                        <b-table
                                :data="isEmpty ? [] : ordersListCompute "
                                bordered
                                striped
                                narrowed
                                hoverable
                                :loading="isLoading"
                                focusable
                                mobile-cards
                        >
                            <!--            checkable-->
                            <!--            :selected.sync="rowsSelected"-->





                                <b-table-column  label="OrderLab No." centered v-slot="props">
                                    {{ props.row.idlaborder }}
                                </b-table-column>
                                <b-table-column label="OPD no."   centered v-slot="props">
                                    {{props.row.opd_no}}
                                </b-table-column>
                                <b-table-column label="Pet Name"  centered v-slot="props">
                                    {{props.row.opd_name}}
                                </b-table-column>
                                <b-table-column label="Owner Name"  centered v-slot="props">
                                    {{props.row.owner_name}}
                                </b-table-column>
                                <b-table-column label="Date/Time"  centered v-slot="props">
                                    {{customFormatDateF(props.row.date)}} - {{props.row.time}}
                                </b-table-column>
                                <b-table-column label="Group of /Request"  centered v-slot="props">
                                    {{props.row.grp_name}}
                                </b-table-column>
                                <b-table-column label="Requested By"  centered v-slot="props">
                                    {{props.row.user_rec_name}}
                                </b-table-column>
                                <b-table-column label="Assign/Create Lab No."  centered v-slot="props">
                                    <b-button type="is-info" @click="showAssignJob(props.row)"  :disabled="!userRoleFind(2)" >Assign</b-button>
                                </b-table-column>

                                <!-- <b-table-column label="Create LIS LAB"  centered v-slot="props">
                                    <b-button type="is-info is-light" @click="showAssignJob(props.row)"  :disabled="!userRoleFind(2)" >Assign For LIS LAB</b-button>
                                 </b-table-column>     -->

                                <b-table-column label="Delete"  centered v-slot="props">
                                    <b-button type="is-danger" @click="toDelete(props.row.idlaborder)" :disabled="!userRoleFind(2)" >Delete</b-button>
                                </b-table-column>







                            <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing here.</p>
                                    </div>
                                </section>
                            </template>
                            <template slot="footer"  >
        <!--                        <div class="box" >-->
                                    <!--                    <div  class="level-left" >    <b>Total checked</b>: {{ checkedRows.length }}</div>-->
                                    <!--                    {{ rowsSelected }}-->
        <!--                        </div>-->
                            </template>
                            <!--                                                <template slot="bottom-left">-->
                            <!--                                                    <b>Total checked</b>: {{ checkedRows.length }}-->


                            <!--                                                </template>-->

                            <!--                                                <div class="box ">-->
                            <!--&lt;!&ndash;                                                    <div  class="level-left" > <div class="level-item"> <b>Total checked</b>: {{ checkedRows.length }}</div></div>&ndash;&gt;-->
                            <!--                                                    <div  class="level-right" > <div class="level-item"> <b-button type="is-primary" outlined v-show="lnList.length>0" >More..</b-button></div></div>-->
                            <!--                                                </div>-->

                        </b-table>

        <AssignedJob  v-if="isAssignedJob"
                      :isShowAssignedJob="isAssignedJob"
                      :dataToChild="rowSelected"
                      @close="closeDlgAssignedJob"
        />


        <CompletedOrders  ref="CompletedOrders"/>
        <ConfirmToDeleteOrder  v-if="isConfirmToDeleteOrder" ref="ConfirmToDeleteOrder"  @close="closeDeleteOrder"  :dataToChild="idToDelete" :isConfirmToDeleteOrder="isConfirmToDeleteOrder"/>


    </div>
</template>

<script>
    /* eslint-disable no-console */
    import {mapActions, mapState} from "vuex"
    import AssignedJob from "./AssignedJob"
    import { customFormatDate }  from '@/utils.js'
    // import { customFormatDate , getBaseURLforBackEnd , getConfigAxios}  from '@/utils.js'
    // import axios from "axios"
    import CompletedOrders from "./CompletedOrders";
    import userRoleFind from "../../mixins/methods/userRoleFind";
    import ConfirmToDeleteOrder from "./ConfirmToDeleteOrder";
    import reloadMyJobsTray from "../../mixins/methods/reloadMyJobsTray";


    export default {
        name: "OrdersList" ,
        components:{
            AssignedJob,
            CompletedOrders,
            ConfirmToDeleteOrder
        },
        mounted() {
            const vm = this
            this.fetchOrdersList()
              .then(res =>{
                  res.forEach(dat=>{
                      dat.grp_value_arr.forEach(grp_value_arr=>{
                          if (vm.datGrpUniqs.indexOf(grp_value_arr) === -1){
                              vm.datGrpUniqs.push(grp_value_arr)
                              vm.datWantToSee.push(grp_value_arr)
                          }
                      })
                    })
                   })






        },
        watch:{
            // ordersList: {
            //     handler: function(val){
            //        console.log('val watch')
            //        console.log(val)
            //     }
            // }
        },

        mixins:[userRoleFind,reloadMyJobsTray],
        created() {
            this.fetchOrdersList()

            //
            // console.log('grp_value_arr')





            // for(var i=0;i<this.ordersList.length;i++){
                // console.log('for xgrp_value_arr')
                // const grp_value_arr_ = this.ordersList[i].grp_value_arr
                // if (this.datGrpUniqs.indexOf(grp_value_arr_) === -1) {
                //     this.datGrpUniqs.push(grp_value_arr_)
                //     this.datWantToSee.push(grp_value_arr_)
                // }
            // }

        },
        computed:{
            ...mapState({
                ordersList: state => state.orders.ordersList,
                user_role: state => state.master_data.user_role,
                user_id : state => state.master_data.user_id ,
             
            }),

            ordersListCompute : function () {
                // return this.ordersList
                return   this.ordersList.filter(dat=>{
                    const  rawDat =  dat.grp_value_arr //['Biopsy','Cytology123']
                    for(var i = 0;i<rawDat.length;i++){
                        if(this.datWantToSee.indexOf(rawDat[i]) !== -1){
                            return dat
                            // continue;
                        }
                    }
                })
            }

        },
        methods:{
            ...mapActions({
                fetchOrdersList : 'orders/fetchOrdersList',
                fetchMyJobsTray: 'myjobstray/fetchMyJobsTray',
            }),
            // userRoleFind: function(idrole){
            //     const tmp = this.user_role.find(dat =>{
            //         return dat.id === idrole
            //     })
            //     return typeof tmp !== 'undefined' ? true : false
            // },
            completedOrder(){
                this.$refs.CompletedOrders.isComponentModalActive = true
            },
            closeDeleteOrder(){
                this.isConfirmToDeleteOrder = false
                this.fetchOrdersList()
            },
            toDelete(id){

                this.idToDelete = id
                this.isConfirmToDeleteOrder = true

            },
            reloadNewOrder(){
                const vm =this
                this.isLoading = true
                this.fetchOrdersList()
                    .then(res =>{
                        res.forEach(dat=>{
                            dat.grp_value_arr.forEach(grp_value_arr=>{
                                if (vm.datGrpUniqs.indexOf(grp_value_arr) === -1){
                                    vm.datGrpUniqs.push(grp_value_arr)
                                    vm.datWantToSee.push(grp_value_arr)
                                }
                            })
                        })
                        this.isLoading = false
                    })

            },
            showAssignJob(row){
               // console.log(row)
                this.rowSelected = row
                if(this.rowSelected) {
                    this.isAssignedJob = true
                }
            },
            closeDlgAssignedJob(){
             this.isAssignedJob = false
             // this.$buefy.toast.open(`Lab Order  has been assigned `)
             // delete from local
             this.fetchOrdersList()
             this.reloadMyJobsTray()
            },
            customFormatDateF(dat){
                return customFormatDate(dat)
            }
        },
        data(){
            return {
                isLoading : false,
                // checkedRows: [],
                // rowsSelected : null,
                isAssignedJob: false,
                isConfirmToDeleteOrder  : false,
                isEmpty: false,
                rowSelected : null ,
                idToDelete : null,


                datGrpUniqs : [],
                datWantToSee : []

            }
        }
    }
</script>

<style scoped>

</style>